"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleChipGroup = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const components_1 = require("../components");
const Label_1 = require("../components/Label");
const Css_1 = require("../Css");
const useTestIds_1 = require("../utils/useTestIds");
function ToggleChipGroup(props) {
    const { values, label, options, hideLabel } = props;
    const state = (0, react_stately_1.useCheckboxGroupState)({ ...props, value: values });
    const { groupProps, labelProps } = (0, react_aria_1.useCheckboxGroup)(props, state);
    const tid = (0, useTestIds_1.useTestIds)(props, "toggleChip");
    return ((0, jsx_runtime_1.jsxs)("div", { ...groupProps, css: Css_1.Css.relative.$, children: [(0, jsx_runtime_1.jsx)(Label_1.Label, { label: label, ...labelProps, hidden: hideLabel }), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.gap1.add("flexWrap", "wrap").$, children: options.map((o) => ((0, jsx_runtime_1.jsx)(ToggleChip, { value: o.value, groupState: state, selected: state.value.includes(o.value), label: o.label, disabled: o.disabled, ...tid[o.value] }, o.value))) })] }));
}
exports.ToggleChipGroup = ToggleChipGroup;
function ToggleChip(props) {
    const { label, value, groupState, selected: isSelected, disabled = false, ...others } = props;
    const isDisabled = !!disabled;
    const ref = (0, react_1.useRef)(null);
    const { inputProps } = (0, react_aria_1.useCheckboxGroupItem)({ value, "aria-label": label, isDisabled }, groupState, ref);
    const { isFocusVisible, focusProps } = (0, react_aria_1.useFocusRing)();
    const tooltip = (0, components_1.resolveTooltip)(disabled);
    return (0, components_1.maybeTooltip)({
        title: tooltip,
        placement: "top",
        children: ((0, jsx_runtime_1.jsxs)("label", { css: {
                ...Css_1.Css.relative.dib.br16.sm.px1.cursorPointer.pyPx(4).bgGray200.if(isDisabled).cursorNotAllowed.gray600.pr1.$,
                ...(isSelected
                    ? {
                        ...Css_1.Css.white.bgLightBlue700.$,
                        ":hover:not([data-disabled='true'])": Css_1.Css.bgLightBlue800.$,
                    }
                    : { ":hover:not([data-disabled='true'])": Css_1.Css.bgGray300.$ }),
                ...(isFocusVisible ? Css_1.Css.bshFocus.$ : {}),
            }, "data-selected": isSelected, "data-disabled": isDisabled, "aria-disabled": isDisabled, ...others, children: [(0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: (0, jsx_runtime_1.jsx)("input", { ...inputProps, ...focusProps }) }), label] })),
    });
}
